import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';
import ConversationListCell from "../LandingPage/ConversationListCell";
import NewConversationTab from "../LandingPage/NewConversation";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import HWLog from "../HWLibrary/HWLog";
import CircularProgress from '@material-ui/core/CircularProgress';

class ConversationList extends Component {

    constructor(props) {
        super(props);
        this.conversationListRef = React.createRef();
    }

    render() {
        let conversations = this.props.conversations || [];
        let isFetchingConversations = this.props.isFetchingConversations || false;
        return (
            <div className="s360-conversation-list-container" style={this.containerStyle()}>
                <div className="s360-conversation-list-all-conversation" style={this.allConversationStyle()}>
                    All Conversations
                </div>
                <div ref={this.conversationListRef} onScroll={this.onConversationListScroll} className="s360-conversation-list-conversation-cell" >
                    {conversations.map((conversation) =>
                        <ConversationListCell key={conversation.sessionId + "session-id-cell"} {...this.props} conversation={conversation} />)}
                    {isFetchingConversations && (<div className="s360-conversation-history-list-cell-activity-indicator" style={{ color: this.props.config.designDetails.headerColor || 'lightgray' }}>
                        <CircularProgress color="inherit" size={20} />
                    </div>)}
                </div>
                <div className="s360-conversation-list-new-conversation-tab-container">
                    {(this.props.config.configDetails.startNewSession || (this.props.areAllPreviousSessionsClosed?true:false)) && (<NewConversationTab {...this.props} />)}
                </div>
                <div className="s360-conversation-list-default-footer">
                    <DefaultFooter {...this.props} />
                </div>
            </div>
        )
    }

    containerStyle = () => {
        let config = this.props.config;
        return {
            backgroundColor: config.designDetails.pageBackgroundColor
        }
    }

    allConversationStyle = () => {
        return {
            fontFamily: this.props.config.designDetails.messageFont,
            fontSize:   this.props.config.designDetails.messageFontSize+"px",
            color:      this.props.config.designDetails.messageFontColor
        }
    }

    onConversationListScroll = () => {
        let scrollContainer = this.conversationListRef.current;
        let isBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight;
        if (isBottom) {
            this.props.onScrollToBottom();
        }
    }

}
export default ConversationList;